// @flow

import { SystemCSSProperties } from "@chakra-ui/react";

export const SpinnerWrapper: SystemCSSProperties = {
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
};
